<shrd-pf-ft-contact-header></shrd-pf-ft-contact-header>

<div class="position-relative">
  <div
    shrdUicScrollbar
    [scrollBarVerticalRef]="scrollbar"
    class="contact-body content-box"
    [scrollContentRef]="contactBody.nativeElement"
  >
    <shrd-pf-ft-contact-body [userData]="userData"></shrd-pf-ft-contact-body>
  </div>
  <shrd-uic-scrollbar #scrollbar></shrd-uic-scrollbar>
</div>

<shrd-pf-ft-contact-footer [userData]="userData"></shrd-pf-ft-contact-footer>
